export function getDurationText(second: number) {
  const minutes = Math.floor(second / 60);
  const minutesText = minutes > 9 ? minutes.toString() : '0' + minutes.toString();
  const seconds = second % 60;
  const secondsText = seconds > 9 ? seconds.toString() : '0' + seconds.toString();
  const timeResult = minutesText + ':' + secondsText;
  return timeResult;
}

export function currentTimeMillis() {
  return Date.now();
}

/// 仅返回时间，不含日期
/// Flutter 原生对十二进制的处理，如下：
/// 1634529600000 10-18 12:00 > 10-18 下午 00:00
/// 1634529660000 10-18 12:01 > 10-18 下午 00:01
/// 1634533200000 10-18 13:00 > 10-18 下午 01:00
/// 1634572800000 10-18 24:00 > 10-19 上午 00:00
/// 1634486400000 10-18 00:00 > 10-18 上午 00:00
/// 以上处理是符合十二进制的规则的，但对于「下午 00:00」理解起来比较费力
/// 所以单独抽了个「中午」一个小时的时段，其他的不变：
/// 1634529600000 10-18 12:01 > 10-18 中午 12:01
/// 1634533200000 10-18 13:00 > 10-18 下午 01:00
export function getOnlyTime(millSecondsSinceEpoch?: number) {
  if (!millSecondsSinceEpoch || millSecondsSinceEpoch <= 0) return '';
  const checkDate = new Date(millSecondsSinceEpoch);
  const checkHour = checkDate.getHours();

  let checkAmOrPm = '';
  let checkHour12 = '';
  if (checkHour >= 0 && checkHour < 12) {
    checkAmOrPm = '上午'
    checkHour12 = `${_addLeadingZeroIfNeeded(checkHour % 12)}`;
  } else if (checkHour === 12) {
    checkAmOrPm = '中午'
    checkHour12 = '12';
  } else if (checkHour > 12) {
    checkAmOrPm = '下午';
    checkHour12 = `${_addLeadingZeroIfNeeded(checkHour % 12)}`
  }

  const checkMin = checkDate.getMinutes();
  const time = `${checkHour12}:${_addLeadingZeroIfNeeded(checkMin)}`;
  return `${checkAmOrPm} ${time}`;
}

/**
 * 仅返回日期，不含时间，但当天除外（含时间）
 * @param millSecondsSinceEpoch
 * @returns
 */
export function getOnlyDateExceptToday(millSecondsSinceEpoch: number) {
  if (!millSecondsSinceEpoch || millSecondsSinceEpoch <= 0) return '';
  const checkDateTime = new Date(millSecondsSinceEpoch);
  const nowDateTime = new Date();
  if (isSameDay(checkDateTime, nowDateTime)) {
    return getOnlyTime(millSecondsSinceEpoch);
  } else if (isYesterday(checkDateTime)) {
    return '昨天';
  } else if (nowDateTime.getFullYear() === checkDateTime.getFullYear()) {
    return `${_addLeadingZeroIfNeeded(checkDateTime.getMonth() + 1)}/${_addLeadingZeroIfNeeded(checkDateTime.getDate())}`;
  } else {
    return `${checkDateTime.getFullYear()}/${_addLeadingZeroIfNeeded(checkDateTime.getMonth() + 1)}/${_addLeadingZeroIfNeeded(checkDateTime.getDate())}`;
  }
}

/**
 * 仅返回日期
 * @param millSecondsSinceEpoch
 * @returns
 */
export function getOnlyDate(millSecondsSinceEpoch: number) {
  if (!millSecondsSinceEpoch || millSecondsSinceEpoch <= 0) return '';
  const checkDateTime = new Date(millSecondsSinceEpoch);
  return `${checkDateTime.getFullYear()}/${_addLeadingZeroIfNeeded(checkDateTime.getMonth() + 1)}/${_addLeadingZeroIfNeeded(checkDateTime.getDate())}`;
}

/**
 * 返回日期 & 时间
 * @param millSecondsSinceEpoch
 * @returns
 */
export function getDateAndTime(millSecondsSinceEpoch: number) {
  if (!millSecondsSinceEpoch || millSecondsSinceEpoch <= 0) return '';
  const checkDateTime = new Date(millSecondsSinceEpoch);
  const nowDateTime = new Date();
  let day = '';
  if (isYesterday(checkDateTime)) {
    day = '昨天 ';
  } else if (nowDateTime.getFullYear() === checkDateTime.getFullYear()) {
    day = `${_addLeadingZeroIfNeeded(checkDateTime.getMonth() + 1)}/${_addLeadingZeroIfNeeded(checkDateTime.getDate())} `;
  } else {
    day = `${checkDateTime.getFullYear()}/${_addLeadingZeroIfNeeded(checkDateTime.getMonth() + 1)}/${_addLeadingZeroIfNeeded(checkDateTime.getDate())} `;
  }
  return `${day}${getOnlyTime(millSecondsSinceEpoch)}`;
}

export function _addLeadingZeroIfNeeded(value: number) {
  if (value < 10) return `0${value}`;
  return value.toString();
}

export function isSameDay(timeOne: Date, timeTwo: Date) {
  return (timeOne.getFullYear() === timeTwo.getFullYear())
  && (timeOne.getMonth() === timeTwo.getMonth())
  && (timeOne.getDate() === timeTwo.getDate());
}

export function isYesterday(targetDateTime: Date) {
  const yesterdayDateTime = Date.now() - 24 * 60 * 60 * 1000;
  const yesterDate= new Date(yesterdayDateTime);
  return isSameDay(yesterDate, targetDateTime);
}